import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css'; // Importa los estilos de Swiper
import { Col } from 'react-bootstrap';
import { ImagesPressLogosWhiteSpiritoryLogoSvg } from '@/assets/images_press_logos_white.assets';
import Image from 'next/image';
import { Autoplay } from 'swiper/modules';
import { useTranslation } from 'next-i18next';

export default function SpiritoryBottleSliderBanner() {
  const { t: tCommon } = useTranslation('common');
  return (
    <Swiper
      spaceBetween={50}
      slidesPerView={1}
      loop={true}
      autoplay={{ delay: 5000 }}
      modules={[Autoplay]}
    >
      <SwiperSlide>
        <Col className="tw-text-center tw-text-white tw-bg-main-shades-600 tw-rounded-lg tw-p-0.5 tw-cursor-pointer">
          <div className="tw-relative tw-flex tw-flex-col tw-items-center tw-py-1">
            <Image
              src={ImagesPressLogosWhiteSpiritoryLogoSvg}
              alt="Spiritory Logo"
              width={50}
              height={50}
              className="tw-absolute tw-left-2 -tw-translate-y-2/4 tw-top-2/4"
            />
            <div className="tw-flex tw-justify-center tw-items-center">
              <div className="tw-col-span-10">
                <h2 className="mb-0 fw-bold tw-text-2xl max-nine:tw-text-xl">
                  {tCommon('spiritorySliderBanner.now_or_never.title')}
                </h2>
                <p className="mb-0">
                  {tCommon('spiritorySliderBanner.now_or_never.subtitle')}
                </p>
              </div>
            </div>
          </div>
        </Col>
      </SwiperSlide>

      <SwiperSlide>
        <Col className="tw-text-center tw-text-white tw-bg-blue-700 tw-rounded-lg tw-p-0.5">
          <div className="tw-relative tw-flex tw-flex-col tw-items-center tw-py-1">
            <Image
              src={ImagesPressLogosWhiteSpiritoryLogoSvg}
              alt="Spiritory Logo"
              width={50}
              height={50}
              className="tw-absolute tw-left-2 -tw-translate-y-2/4 tw-top-2/4"
            />
            <div className="tw-flex tw-items-center tw-justify-center">
              <div>
                <h2 className="mb-0 fw-bold tw-text-2xl max-nine:tw-text-xl">
                  {tCommon('spiritorySliderBanner.last_chance.title')}
                </h2>
                <p className="mb-0">
                  {tCommon('spiritorySliderBanner.last_chance.subtitle')}
                </p>
              </div>
            </div>
          </div>
        </Col>
      </SwiperSlide>

      <SwiperSlide>
        <Col className="tw-text-center tw-text-white tw-bg-main-shades-600 tw-rounded-lg tw-p-0.5">
          <div className="tw-relative tw-flex tw-flex-col tw-items-center tw-py-1">
            <Image
              src={ImagesPressLogosWhiteSpiritoryLogoSvg}
              alt="Spiritory Logo"
              width={50}
              height={50}
              className="tw-absolute tw-left-2 -tw-translate-y-2/4 tw-top-2/4"
            />
            <div className="tw-flex tw-items-center tw-justify-center">
              <div>
                <h2 className="mb-0 fw-bold tw-text-2xl max-nine:tw-text-xl">
                  {tCommon('spiritorySliderBanner.act_fast.title')}
                </h2>
                <p className="mb-0">
                  {tCommon('spiritorySliderBanner.act_fast.subtitle')}
                </p>
              </div>
            </div>
          </div>
        </Col>
      </SwiperSlide>

      <SwiperSlide>
        <Col className="tw-text-center tw-text-white tw-bg-main-shades-600 tw-rounded-lg tw-p-0.5">
          <div className="tw-relative tw-flex tw-flex-col tw-items-center tw-py-1">
            <Image
              src={ImagesPressLogosWhiteSpiritoryLogoSvg}
              alt="Spiritory Logo"
              width={50}
              height={50}
              className="tw-absolute tw-left-2 -tw-translate-y-2/4 tw-top-2/4"
            />
            <div className="tw-flex tw-items-center tw-justify-center">
              <div>
                <h2 className="mb-0 fw-bold tw-text-2xl max-nine:tw-text-xl">
                  {tCommon('spiritorySliderBanner.big_deal.title')}
                </h2>
                <p className="mb-0">
                  {tCommon('spiritorySliderBanner.big_deal.subtitle')}
                </p>
              </div>
            </div>
          </div>
        </Col>
      </SwiperSlide>
    </Swiper>
  );
}
